import { eTransactionCategory } from '../../../ui-toolkit/enums/eTransactionType';
import { ePartyPurpose } from '../../../ui-toolkit/enums/ePartyPurpose';
import { IParty } from '../../../ui-toolkit/orders/interfaces/IParty';
import { IOrderDetailsData } from '../../../ui-toolkit/orders/interfaces/IOrderDetailsData';

const mapParties =
  (x: eTransactionCategory) =>
  (party: IParty): IParty => {
    if (x === eTransactionCategory.Refinance || party.purpose !== ePartyPurpose.borrower) {
      return party;
    }

    return {
      ...party,
      purpose: ePartyPurpose.buyer,
    };
  };

export const transformServiceToForm = (oldData: IOrderDetailsData): IOrderDetailsData => {
  return {
    ...oldData,
    parties: oldData.parties.map(mapParties(oldData.transaction.transaction_category)),
  };
};
